import styled from 'styled-components';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';

export const InvitationUrlWrapper = styled(Box)({
  display: 'grid',
  gridTemplateColumns: '1fr auto',
  gap: 8,
  marginTop: 16,
  alignItems: 'end',
});
